// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__UEw_D","text":"SelectPayment_text__1in7u","title":"SelectPayment_title__ZmTUX","btn":"SelectPayment_btn__2JJ5T"};